import {
  READ_REQUESTS_FILTERS_FAILURE,
  READ_REQUESTS_FILTERS_REQUEST,
  READ_REQUESTS_FILTERS_SUCCESS,
  RequestsFiltersActionTypes,
  RequestsFiltersState,
} from './types';

const defaultState: RequestsFiltersState = {
  isLoading: false,
  errorMessage: '',
};

function requestsFilters(
  state = defaultState,
  action: RequestsFiltersActionTypes
): RequestsFiltersState {
  switch (action.type) {
    case READ_REQUESTS_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case READ_REQUESTS_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: '',
      };
    case READ_REQUESTS_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}

export default requestsFilters;
